import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, DatePicker } from "shards-react";
import moment from "moment";
import { FiSearch } from "react-icons/fi";
import PageTitle from "../components/common/PageTitle";
import SmallStats from "../components/common/SmallStats";
import UsersOverview from "../components/blog/UsersOverview";
import UsersByDevice from "../components/blog/UsersByDevice";
import TopReferrals from "../components/common/TopReferrals";
import { Link } from "react-router-dom";
import { FcPlus } from "react-icons/fc";
import BatchReportService from "../services/batchReport.service";
import SupplierService from "../services/supplier.service";
import { actions as AppActions } from "../_stores/app.store";

class BlogOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateFrom: moment().subtract(1, "months").toDate(),
      dateTo: moment().toDate(),
      smallStats: [...TopRowStats],
      batches_all: 0,
      batches_pending: 0,
      batches_completed: 0,
      batches_failed: 0,
      suppliers_total: [],
      suppliers_configured: [],
      month_view: {
        labels: [],
        pending: [],
        failed: [],
        completed: [],
      },
      top_suppliers: [],
    };
    this.applyFilter = this.applyFilter.bind(this);
  }

  componentDidMount() {
    this.fetchSuppliers();
  }

  dateChanged(dVal, dKey) {
    this.setState({ [dKey]: dVal });
  }

  fetchSuppliers() {
    const { suppliers_total } = this.state;
    AppActions.setLoading(true);
    if (suppliers_total.length) {
      this.setSupplierConfigured(suppliers_total);
      this.fetchBatchReport(suppliers_total);
    } else {
      let suplist = [];
      SupplierService.getAll()
        .then((response) => {
          if (response.data && response.data.data && response.data.data.length)
            suplist = response.data.data;
          this.setState({ suppliers_total: suplist });
          this.setSupplierConfigured(suplist);
          this.fetchBatchReport(suplist);
        })
        .catch((error) => {
          AppActions.setLoading(false);
          console.log("fetch suppliers catch => ", error);
        });
    }
  }

  setSupplierConfigured(supplierlist) {
    const { dateFrom, dateTo } = this.state;
    const sup_confgrd = supplierlist.reduce((arr, sup) => {
      if (moment(sup.createdAt).isBetween(dateFrom, dateTo, "days", []))
        arr.push(sup);
      return arr;
    }, []);
    this.setState({
      suppliers_configured: sup_confgrd,
      smallStats: this.state.smallStats.map((smt, inx) => {
        if (inx === 3)
          smt.value = `${sup_confgrd.length}/${supplierlist.length}`;
        return smt;
      }),
    });
  }

  fetchBatchReport(supplierList) {
    const { dateFrom, dateTo } = this.state;
    BatchReportService.fetchByDates({
      dateFrom,
      dateTo,
      dateField: "updatedAt",
      sortOrder: "asc",
    })
      .then((response) => {
        AppActions.setLoading(false);
        if (response.data && response.data.data && response.data.data.length) {
          this.categoriseBatchReport(response.data.data, supplierList);
          this.composeMonthlyOverview(response.data.data);
        }
      })
      .catch((error) => {
        AppActions.setLoading(false);
        console.log("fetch batch report catch => ", error);
      });
  }

  categoriseBatchReport(btch_all, suplr_all) {
    const supplierBatchObj = {};
    const btch_pending = [],
      btch_failed = [],
      btch_completed = [];

    for (let i = 0; i < btch_all.length; i++) {
      const btchitem = btch_all[i];
      const sup_code = btchitem.supplierCode;

      supplierBatchObj[sup_code] = supplierBatchObj[sup_code]
        ? ++supplierBatchObj[sup_code]
        : 1;

      switch (btchitem.step) {
        case "downloaded":
        case "pending":
        case "validation":
        case "File Process":
          btch_pending.push(btchitem);
          break;
        case "failed":
          btch_failed.push(btchitem);
          break;
        case "process":
        case "complete":
        case "cancelled":
        case "uploaded":
          btch_completed.push(btchitem);
          break;
        default:
          console.info("Default case in segregating batch reports.");
      }
    }

    const top_suplrs = Object.entries(supplierBatchObj)
      .sort(([, valA], [, valB]) => valB - valA)
      .slice(0, 5)
      .map(([sKey, sVal]) => {
        const supInx = suplr_all.findIndex(
          (suplr) => suplr.supplierCode == sKey
        );
        return supInx !== -1
          ? { title: suplr_all[supInx].supplierName, value: sVal }
          : { title: sKey, value: sVal };
      });

    const { smallStats } = this.state;
    this.setState({
      top_suppliers: top_suplrs,
      batches_all: btch_all,
      batches_pending: btch_pending,
      batches_failed: btch_failed,
      batches_completed: btch_completed,
      smallStats: [
        { ...smallStats[0], value: btch_all.length },
        {
          ...smallStats[1],
          value: `${btch_failed.length}/${btch_completed.length}`,
        },
        { ...smallStats[2], value: btch_pending.length },
        { ...smallStats[3] },
      ],
    });
  }

  composeMonthlyOverview(btch_list) {
    const { dateTo, dateFrom } = this.state;
    const enddate = moment(dateTo);
    const startdate = moment(dateFrom);
    const dayArr = [],
      pendingArr = [],
      failedArr = [],
      completedArr = [];
    let batchCntr = 0,
      batchItm = undefined;
    while (startdate.isSameOrBefore(enddate)) {
      dayArr.push(startdate.format("DD MMM"));
      pendingArr.push(0);
      failedArr.push(0);
      completedArr.push(0);
      while (batchCntr < btch_list.length) {
        batchItm = btch_list[batchCntr];
        if (moment(batchItm.updatedAt).isSame(startdate, "day")) {
          switch (batchItm.step) {
            case "downloaded":
            case "validation":
            case "File Process":
              pendingArr[pendingArr.length - 1]++;
              break;
            case "failed":
              failedArr[failedArr.length - 1]++;
              break;
            case "process":
            case "complete":
            case "cancelled":
            case "uploaded":
              completedArr[completedArr.length - 1]++;
              break;
            default:
            // console.info("Default case in monthly overview switch.");
          }
          batchCntr++;
        } else {
          break;
        }
      }
      startdate.add(1, "days");
    }
    this.setState({
      month_view: {
        labels: dayArr,
        pending: pendingArr,
        failed: failedArr,
        completed: completedArr,
      },
    });
  }

  applyFilter() {
    this.fetchSuppliers();
  }

  render() {
    const {
      smallStats,
      dateFrom,
      dateTo,
      batches_pending,
      batches_failed,
      batches_completed,
      month_view,
      top_suppliers,
    } = this.state;

    return (
      <Container fluid className="main-content-container px-4">
        {/* Page Header */}
        <Row noGutters className="page-header bg-red py-4 dashboard-header">
          <PageTitle
            title="Dashboard"
            subtitle=""
            className="text-sm-left mb-3"
            xs="auto"
            sm="auto"
            md="auto"
          />

          <Col md="7" className="">
            <Row>
              <Col md="5">
                <label className="mb-0">From Date</label>
                <DatePicker
                  selected={dateFrom}
                  onChange={(dt) => this.dateChanged(dt, "dateFrom")}
                  placeholderText="Select"
                  dropdownMode="select"
                  dateFormat="dd/MM/yyyy"
                />
              </Col>
              <Col md="5">
                <label className="mb-0">To Date</label>
                <DatePicker
                  selected={dateTo}
                  onChange={(dt) => this.dateChanged(dt, "dateTo")}
                  placeholderText="Select"
                  dropdownMode="select"
                  dateFormat="dd/MM/yyyy"
                />
              </Col>
              <Col md="auto" className="d-flex">
                <button
                  className="btn theme-search mt-auto"
                  onClick={this.applyFilter}
                  disabled={!dateFrom || !dateTo}
                >
                  <FiSearch size={16} />
                </button>
              </Col>
            </Row>
          </Col>

          {/* <Col md="auto">
            <Link className="btn btn-primary" to={"create-project"}>
              <FcPlus /> Create Project
            </Link>
          </Col> */}
        </Row>

        {/* Small Stats Blocks */}
        <Row>
          {smallStats.map((stats, idx) => (
            <Col className="col-lg mb-4" key={idx} {...stats.attrs}>
              <SmallStats
                id={`small-stats-${idx}`}
                variation="1"
                chartData={stats.datasets}
                chartLabels={stats.chartLabels}
                label={stats.label}
                value={stats.value}
                percentage={stats.percentage}
                increase={stats.increase}
                decrease={stats.decrease}
              />
            </Col>
          ))}
        </Row>

        <Row>
          {/* Users Overview */}
          <Col lg="8" md="12" sm="12" className="mb-4">
            <UsersOverview
              labels={month_view.labels}
              completed={month_view.completed}
              failed={month_view.failed}
              pending={month_view.pending}
            />
          </Col>

          {/* Users by Device */}
          <Col lg="4" md="6" sm="12" className="mb-4">
            <UsersByDevice
              completed={batches_completed.length}
              pending={batches_pending.length}
              failed={batches_failed.length}
            />
          </Col>

          {/* New Draft 
        <Col lg="4" md="6" sm="12" className="mb-4">
          <NewDraft />
        </Col>
  
        {/* Discussions
        <Col lg="5" md="12" sm="12" className="mb-4">
          <Discussions />
        </Col>
  
        {/* Top Referrals */}
          <Col lg="6" md="12" sm="12" className="mb-4">
            <TopReferrals topSuppliers={top_suppliers} />
          </Col>
        </Row>
      </Container>
    );
  }
}

BlogOverview.propTypes = {
  /**
   * The small stats dataset.
   */
  // smallStats: PropTypes.array,
};

// BlogOverview.defaultProps = {};
const TopRowStats = [
  {
    label: "Files Received",
    value: "0",
    percentage: "0%",
    increase: false,
    decrease: true,
    chartLabels: [null, null, null, null, null, null, null],
    attrs: { md: "4", sm: "6" },
    datasets: [
      {
        label: "Today",
        fill: "start",
        borderWidth: 1.5,
        backgroundColor: "rgb(0,123,255,0.1)",
        borderColor: "rgb(0,123,255)",
        data: [3, 2, 3, 2, 4, 5, 4],
      },
    ],
  },
  {
    label: "Files Failed / Completed",
    value: "0",
    percentage: "0%",
    increase: false,
    decrease: true,
    chartLabels: [null, null, null, null, null, null, null],
    attrs: { md: "4", sm: "6" },
    datasets: [
      {
        label: "Today",
        fill: "start",
        borderWidth: 1.5,
        backgroundColor: "rgba(255,65,105,0.1)",
        borderColor: "rgb(255,65,105)",
        data: [1, 7, 1, 3, 1, 4, 8],
      },
    ],
  },
  {
    label: "Records Pending",
    value: "0",
    percentage: "0%",
    increase: true,
    chartLabels: [null, null, null, null, null, null, null],
    attrs: { md: "6", sm: "6" },
    datasets: [
      {
        label: "Today",
        fill: "start",
        borderWidth: 1.5,
        backgroundColor: "rgba(23,198,113,0.1)",
        borderColor: "rgb(23,198,113)",
        data: [1, 2, 3, 3, 3, 4, 4],
      },
    ],
  },
  {
    label: "Suppliers Configured",
    value: "0",
    percentage: "0",
    increase: false,
    decrease: true,
    chartLabels: [null, null, null, null, null, null, null],
    attrs: { md: "4", sm: "6" },
    datasets: [
      {
        label: "Today",
        fill: "start",
        borderWidth: 1.5,
        backgroundColor: "rgba(255,180,0,0.1)",
        borderColor: "rgb(255,180,0)",
        data: [2, 3, 3, 3, 4, 3, 3],
      },
    ],
  },
];

export default BlogOverview;
